import { Asset } from '../..';
import { fundsSellOffersQueryUpdated } from '../../../../../../../../store/product/selectors';

import { FundsSellListItem } from './ListItem';
import { ListLoadingItem } from './ListLoadingItem';

export const FundsAsset = () => {
  return (
    <Asset
      productsQuery={fundsSellOffersQueryUpdated}
      ProductItem={FundsSellListItem}
      ProductItemLoading={ListLoadingItem}
      keySelector="productIdNormalized"
    />
  );
};
